import { render } from "./RedeemCode.vue?vue&type=template&id=30dbdb68"
import script from "./RedeemCode.vue?vue&type=script&lang=js"
export * from "./RedeemCode.vue?vue&type=script&lang=js"

import exportComponent from "D:\\my\\game-fe\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__